import { courseStudentsApi } from "api/courseStudentsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const useCourseStudents = (courseId: string | number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_STUDENTS(courseId),
    queryFn: () => courseStudentsApi.fetch(Number(courseId), 0, 1_000_000, ""),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.COURSE_STUDENTS(courseId) });
  };

  return { invalidate, isFetching, isLoading, students: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
